"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IU_NATIVE = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
var instances_1 = require("../../../types/instances");
var microFrontend_1 = require("../../../utils/microFrontend");
var brands_1 = require("../../brands");
var environments_1 = require("../../environments");
var localesAndRegions_1 = require("../../localesAndRegions");
var microFrontends_json_1 = __importDefault(require("./microFrontends.json"));
if (!(0, microFrontend_1.isMicroFrontendDefinition)(microFrontends_json_1.default)) {
    throw new Error('Invalid microFrontends definition.');
}
exports.IU_NATIVE = {
    brand: brands_1.BrandName.IU,
    region: localesAndRegions_1.RegulatoryRegion.DACH,
    deployment: instances_1.MondrianDeploymentType.BUNDLE,
    company: 'IU International University',
    microFrontends: microFrontends_json_1.default,
    apiBaseUrl: (_a = {},
        _a[environments_1.Environment.DEV] = 'https://api-dev.iu.org',
        _a[environments_1.Environment.NONPROD] = 'https://api-non-prod.iu.org',
        _a[environments_1.Environment.PROD] = 'https://api.iu.org',
        _a),
    moodleBaseUrl: (_b = {},
        _b[environments_1.Environment.DEV] = 'https://dev.mycampus.iubh.de',
        _b[environments_1.Environment.NONPROD] = 'https://stage.mycampus.iubh.de',
        _b[environments_1.Environment.PROD] = 'https://mycampus.iubh.de',
        _b),
    meta: {
        title: 'myCampus',
        description: 'myCampus - Embark on your learning journey with the ultimate platform focused on you and your studies!',
        keywords: [
            'IU',
            'my',
            'study',
            'learn',
            'manage',
            'International University',
            'IUBH',
        ],
    },
    hostname: (_c = {},
        _c[environments_1.Environment.PROD] = {
            domain: 'mycampus.iu.org',
            allowImportMapOverrides: false,
        },
        _c[environments_1.Environment.NONPROD] = {
            domain: 'mycampus.iu.org',
            subDomain: 'stage',
            allowImportMapOverrides: true,
        },
        _c[environments_1.Environment.DEV] = {
            domain: 'mycampus.iu.org',
            subDomain: 'dev',
            allowImportMapOverrides: true,
        },
        _c),
};
